import React from 'react';
import { SourceType } from '@/modules/surgicalEvent';
import { SourceTypeTooltip } from './SourceTypeTooltip';
import { TranslatedText } from '@ianesthesie-kit/core';

export const PatientsAppBadge = () => (
  <div className="source-type-icon patients-app">
    <SourceTypeTooltip
      sourceType={SourceType.PATIENTS_APP}
      title={<TranslatedText id="app.sourceType.PATIENTS_APP.explanation" />}
    >
      <PatientsAppBadgeIcon />
    </SourceTypeTooltip>
  </div>
);

export const PatientsAppBadgeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    viewBox="0 0 24 24"
    fill="none"
    className="contain-image"
  >
    <g clipPath="url(#clip0_3290_4151)">
      <path
        d="M17.8614 2.23193C17.8772 1.01795 16.8832 0.021284 15.6413 0.00581593C14.3993 -0.00965212 13.3797 0.961935 13.3639 2.17592C13.348 3.3899 14.342 4.38656 15.584 4.40203C16.8259 4.4175 17.8456 3.44591 17.8614 2.23193Z"
        fill="currentColor"
      ></path>
      <path
        d="M24.1179 13.9753C22.9298 12.3784 22.9298 11.6267 24.1179 10.0298C24.4574 9.57355 24.6271 8.98768 24.5157 8.35516C24.3566 7.44785 23.614 6.722 22.6858 6.56646C22.044 6.45758 21.4393 6.62349 20.9726 6.95531C19.3389 8.11148 18.5698 8.11148 16.9361 6.95531C16.5065 6.6546 15.9655 6.48869 15.3873 6.54572C14.3424 6.64941 13.4884 7.47377 13.3771 8.48996C13.2338 9.81204 14.2894 10.9319 15.6154 10.9319C16.1087 10.9319 16.5648 10.7764 16.9361 10.5068C18.0871 9.6928 18.8085 9.4543 19.7049 9.78612C20.3997 10.0454 20.9566 10.5897 21.2165 11.2637C21.556 12.1399 21.312 12.8451 20.474 13.9701C20.161 14.3901 19.9966 14.9189 20.0549 15.484C20.161 16.5054 21.0044 17.3401 22.044 17.449C23.3965 17.589 24.5422 16.5573 24.5422 15.2611C24.5422 14.7789 24.3831 14.333 24.1073 13.9701L24.1179 13.9753Z"
        fill="currentColor"
      ></path>
      <path
        d="M15.6154 13.0679C14.3742 13.0679 13.3665 14.053 13.3665 15.2662C13.3665 15.7483 13.5256 16.1942 13.8014 16.5571C14.9895 18.154 14.9895 18.9058 13.8014 20.5026C13.5309 20.8656 13.3665 21.3114 13.3665 21.7936C13.3665 23.0068 14.3742 23.9919 15.6154 23.9919C16.8566 23.9919 17.8644 23.0068 17.8644 21.7936C17.8644 21.3114 17.6999 20.8656 17.4294 20.5026C16.2413 18.9058 16.2413 18.154 17.4294 16.5571C17.6999 16.1942 17.8644 15.7483 17.8644 15.2662C17.8644 14.053 16.8566 13.0679 15.6154 13.0679Z"
        fill="currentColor"
      ></path>
      <path
        d="M8.93205 0.00244141C7.69089 0.00244141 6.68311 0.987522 6.68311 2.20073C6.68311 2.6829 6.84753 3.12878 7.11804 3.4917C8.30617 5.08857 8.30617 5.84034 7.11804 7.43721C6.84753 7.80014 6.68311 8.24601 6.68311 8.72818C6.68311 9.94139 7.69089 10.9265 8.93205 10.9265C10.1732 10.9265 11.181 9.94139 11.181 8.72818C11.181 8.24601 11.0219 7.80014 10.7461 7.43721C9.55794 5.84034 9.55794 5.08857 10.7461 3.4917C11.0166 3.12878 11.181 2.6829 11.181 2.20073C11.181 0.987522 10.1732 0.00244141 8.93205 0.00244141Z"
        fill="currentColor"
      ></path>
      <path
        d="M10.7515 20.5028C9.56334 18.9059 9.56334 18.1542 10.7515 16.5573C11.0909 16.101 11.2607 15.5152 11.1493 14.8827C10.9901 13.9753 10.2476 13.2495 9.31935 13.094C8.67755 12.9851 8.07288 13.151 7.60611 13.4828C6.45512 14.2968 5.73376 14.5353 4.83736 14.2035C4.14252 13.9442 3.58559 13.3998 3.32569 12.7258C2.98622 11.8496 3.23021 11.1445 4.06826 10.0195C4.38121 9.59951 4.54563 9.07068 4.48729 8.50555C4.38121 7.48418 3.53785 6.64945 2.49824 6.54058C1.14569 6.40059 0 7.43233 0 8.72849C0 9.21066 0.159124 9.65654 0.434938 10.0195C1.62306 11.6163 1.62306 12.3681 0.434938 13.965C0.0954742 14.4212 -0.0742577 15.0071 0.0371289 15.6396C0.196253 16.5469 0.93883 17.2728 1.86705 17.4283C2.50885 17.5372 3.11352 17.3713 3.58028 17.0395C4.73128 16.2255 5.45264 15.987 6.34904 16.3188C7.04388 16.578 7.60081 17.1224 7.86071 17.7964C8.20018 18.6726 7.95619 19.3777 7.11813 20.5028C6.80519 20.9228 6.64076 21.4516 6.69911 22.0167C6.80519 23.0381 7.64855 23.8728 8.68815 23.9817C10.0407 24.1217 11.1864 23.0899 11.1864 21.7938C11.1864 21.3116 11.0273 20.8657 10.7515 20.5028Z"
        fill="currentColor"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_3290_4151">
        <rect width="169" height="24" fill="currentColor"></rect>
      </clipPath>
    </defs>
  </svg>
);
